import { nanoid } from "nanoid";

const GLOBAL_MAP = new WeakMap<WeakKey, string>();

function refId(key: WeakKey): string {
	const existed = GLOBAL_MAP.get(key);

	if (existed != null) {
		return existed;
	}

	const created = nanoid();

	GLOBAL_MAP.set(key, created);

	return created;
}

export { refId };
